export default __webpack_public_path__ + "static/media/icn-logo.2a794223.svg";